import React, { useEffect, useState } from 'react';

//Third Party packages
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Container, Navbar, Nav, NavDropdown, Col } from 'react-bootstrap';

import { HeaderSVG } from '../../img/GlobalSVG';
import '../../components/commonstyle.scss';
import BreadCrumbs from '../BreadCrumb/breadcrumb';
import ReadonlyBreadCrumb from '../BreadCrumb/ReadonlyBreadCrumb';
import { resetBreadCrumb } from '../../../redux/admin/breadCrumbSlice';
import {
  adminBreadCrumNotShow,
  adminShowReadOnlyBreadCrum,
} from '../../utils/common';
import { logout } from '../../../redux/app/userSlice';
import HttpHeader from '../../shared/httpheader';
import { resetSearchProviderFilters } from '../../../redux/admin/priceCompareSlice';

import helpCenterIcon from '../../img/Help-Center.svg';
import PortalName from 'src/Admin/components/header/PortalName';

export default ({ isSecurityQuestionsAvailable = true }) => {
  const { isLoggedIn, userData } = useSelector((state) => state.user);
  const { isLogoLoaded, logoImage, logoType } = useSelector(
    (state) => state.theme,
  );

  const [breadCrumb, showBreadCrumb] = useState(true);
  const [readOnlyBreadCrumb, setReadOnlyBreadCrumb] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const cName = HttpHeader.getCNAME();

  useEffect(() => {
    if (
      adminShowReadOnlyBreadCrum(location.pathname) &&
      userData?.UserType !== 'Provider'
    ) {
      setReadOnlyBreadCrumb(true);
    } else {
      setReadOnlyBreadCrumb(false);

      //Check Price Compare final screen route. checking condition because at the end of route we have dynamic id
      let finalResultPageOfPC = false;
      const routeChecking = location?.pathname?.split('/');
      if (routeChecking?.length > 4) routeChecking.pop();
      if (routeChecking?.join('/') === '/admin/price-compare/show-result') {
        finalResultPageOfPC = true;
      }
      if (userData?.UserType === 'Provider') {
        showBreadCrumb(false);
      } else {
        if (adminBreadCrumNotShow(location.pathname, finalResultPageOfPC)) {
          showBreadCrumb(false);
        } else {
          showBreadCrumb(true);
        }
      }
    }
  }, [location]);

  const logoutAction = () => {
    dispatch(resetBreadCrumb());
    dispatch(logout({ preserveBearerToken: true }));
    dispatch(resetSearchProviderFilters());
    navigate('/admin/logout');
  };

  const userTypeClassname =
    userData?.UserType == 'Client'
      ? 'header-usertype-employer'
      : '' || userData.UserType === 'Insurer'
      ? 'header-usertype-admin'
      : '' || userData?.UserType == 'Broker'
      ? 'header-usertype-broker'
      : '' || userData?.UserType == 'Provider'
      ? 'header-usertype-provider'
      : '';

  const userType =
    userData?.UserType === 'Client'
      ? 'Employer'
      : null ||
        (userData?.UserType === 'Insurer' && userData.SuperUser === true)
      ? 'Super Admin'
      : '' || (userData?.UserType === 'Insurer' && userData.SuperUser !== true)
      ? 'Insurer'
      : '' || userData?.UserType === 'Broker'
      ? 'Broker'
      : null || userData?.UserType === 'Provider'
      ? 'Provider'
      : null;

  return (
    <>
      <div
        className={`top-header container-offset ${
          !isSecurityQuestionsAvailable ? 'ml-0' : ''
        }`}
      >
        <Container fluid>
          <Row className="d-flex align-items-center">
            <div className={'col-sm-4 col-xs-12'}>
              {isLogoLoaded && (
                <img
                  src={'data:' + logoType + ';base64, ' + logoImage}
                  alt="Company Logo"
                />
              )}
            </div>

            <Col sm={8}>
              <PortalName isSecure={true} />
            </Col>

            {/*<div
              className={
                userData.UserType === 'Client'
                  ? 'col-sm-2 col-xs-2 d-flex employer-block'
                  : 'col-sm-2 col-xs-2 d-flex'
              }
            >
              <span className="pr-1 help-icon">
                <Link to="/admin/help-center">
                  <img src={helpCenterIcon} alt="logo" />
                </Link>
              </span>

              <Navbar collapseOnSelect expand="lg" className="header-navbar">
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className="mr-auto"></Nav>
                  {isLoggedIn && (
                    <Nav className="user-navbar">
                      <span>
                        <HeaderSVG.AvatarSVG />
                      </span>

                      <NavDropdown
                        title={`Hi, ${userData?.FirstName}`}
                        id={
                          userData.UserType == 'Client'
                            ? 'collasible-nav-dropdown-header-emp'
                            : 'collasible-nav-dropdown-header'
                        }
                      >
                        {/*<NavDropdown.Item href="#" className="active">My Profile</NavDropdown.Item>
                        <NavDropdown.Item href="#" >Settings</NavDropdown.Item> *
                        <NavDropdown.Item as={Link} to="/admin/my-profile">
                          My Profile
                        </NavDropdown.Item>
                        <NavDropdown.Item href="#" onClick={logoutAction}>
                          Logout
                        </NavDropdown.Item>
                        <NavDropdown.Divider />
                      </NavDropdown>
                    </Nav>
                  )}
                </Navbar.Collapse>
              </Navbar>

              <div className="d-flex">
                <div
                  className={
                    userData.UserType == 'Client'
                      ? 'userdata-usertype-employer'
                      : 'userdata-usertype'
                  }
                >
                  {userType}
                </div>
                <span className="vertical-divider"></span>
              </div>
            </div>

            <div className="col-sm-2 col-xs-2 pr-0 ">
              <span className="admin-portal-header">ADMIN CENTER</span>
              <div className={userTypeClassname}>
                <span>
                  {userData?.UserType === 'Client'
                    ? 'For Employers'
                    : `For ${userData.UserType}s `}
                </span>
              </div>
            </div>*/}
          </Row>
        </Container>
      </div>

      {/*{ ( breadCrumb || readOnlyBreadCrumb ) && */}
      <div
        className={`top-breadcrumb container-offset ${
          breadCrumb || readOnlyBreadCrumb ? 'd-block' : 'd-none'
        }`}
      >
        <Container fluid>
          <Row>
            <div>
              {/*{ breadCrumb && !readOnlyBreadCrumb && <BreadCrumbs /> } */}
              {<BreadCrumbs isVisible={breadCrumb && !readOnlyBreadCrumb} />}
            </div>

            <div>
              {/*{ readOnlyBreadCrumb && <ReadonlyBreadCrumb /> } */}
              {<ReadonlyBreadCrumb isVisible={readOnlyBreadCrumb} />}
            </div>
          </Row>
        </Container>
      </div>
      {/*} */}
    </>
  );
};
